import { AbstractControl, ValidatorFn } from '@angular/forms';
import { CreativeVO } from 'src/app/data/vo/CreativeVO';
import * as _ from 'lodash';

export function campaignBudgetCreativeValidator(): ValidatorFn {
    return (control: AbstractControl) => {
        let startDateControl: AbstractControl = control.get('startDate');
        let creativesControl: AbstractControl = control.get('creatives');
        let produceCreativeControl: AbstractControl = control.get('produceCreative');
        if (startDateControl.touched || creativesControl.touched || produceCreativeControl.touched) {
            let creatives: Array<CreativeVO> = creativesControl.value;
            let isProduceCreative: boolean = !_.isEmpty(produceCreativeControl.value);
            if (!_.isEmpty(creatives) || isProduceCreative) {
                let isMediacorpCreative: boolean = creatives.some((creative: CreativeVO) => {
                    return creative.creativeAuthor === 'Seller';
                });
                if (isMediacorpCreative || isProduceCreative) {
                    let startDate = getUTCDate(startDateControl.value);
                    let next30Days = getNextUTCDate(30);
                    return startDate != null && startDate > next30Days ? null
                        : isMediacorpCreative ? { invalidSellerCreativeDate: true } : { invalidProduceCreativeDate: true };
                }
                return null;
            }
        }
        return null;
    };
}

export function campaignLanguageCreativeValidator(): ValidatorFn {
    return (control: AbstractControl) => {
        let languagesControl: AbstractControl = control.get('languages');
        let creativesControl: AbstractControl = control.get('creatives');
        let produceCreativeControl: AbstractControl = control.get('produceCreative');
        if (languagesControl.touched || creativesControl.touched || produceCreativeControl.touched) {
            let creatives: Array<CreativeVO> = creativesControl.value;
            let produceCreatives: Array<CreativeVO> = produceCreativeControl.value;
            let languages: Array<string> = languagesControl.value;
            if ((!_.isEmpty(creatives) || !_.isEmpty(produceCreatives)) && _.isEmpty(languages)) {
                return !_.isEmpty(creatives) ? { languagesEmptyForCreative: true } : { languagesEmptyForMediacorpCreative: true };
            } else if ((!_.isEmpty(creatives) || !_.isEmpty(produceCreatives)) && !_.isEmpty(languages)) {
                let isInvalid: boolean = false;
                if (!_.isEmpty(creatives)) {
                    isInvalid = checkCompatibleLanguageForCreatives(creatives, languages);
                    if (isInvalid) {
                        if (!_.isEmpty(produceCreatives)) {
                            isInvalid = checkCompatibleLanguageForCreatives(produceCreatives, languages);
                            if (isInvalid) {
                                return {
                                    invalidLanguagesForCreative: true,
                                    invalidLanguagesForMediacorpCreative: true
                                };
                            }
                        }
                        return { invalidLanguagesForCreative: true };
                    }
                }
                if (!_.isEmpty(produceCreatives)) {
                    isInvalid = checkCompatibleLanguageForCreatives(produceCreatives, languages);
                    if (isInvalid) {
                        return { invalidLanguagesForMediacorpCreative: true };
                    }
                }
            }
        }
        return null;
    }
}

function checkCompatibleLanguageForCreatives(creatives: CreativeVO[], languages: Array<string>): boolean {
    let creativeLanguageMap = {};
    creatives.forEach((c) => {
        if (!creativeLanguageMap[c.language.toUpperCase()]) {
            creativeLanguageMap[c.language.toUpperCase()] = true;
        }
    });
    let creativeLanguages = Object.keys(creativeLanguageMap);
    let isInvalid: boolean = false;
    // check if all language selections contain at least one compatible creative
    if (!creativeLanguageMap['ENGLISH']) {
        // English creative is compatible to all channels
        isInvalid = !languages.every((language) => {
            return creativeLanguages.some((creativeLanguage) => {
                return language.includes(creativeLanguage);
            });
        });
    }
    // check if all creative languages have compatible language selected
    isInvalid = isInvalid || creativeLanguages.some((creativeLanguage) => {
        return creativeLanguage !== 'ENGLISH' && !languages.some((language) => {
            return language.includes(creativeLanguage);
        })
    });
    return isInvalid;
}

export function getUTCDate(timestamp: number) {
    let tdate = new Date(timestamp);
    return Date.UTC(tdate.getUTCFullYear(), tdate.getUTCMonth(), tdate.getUTCDate());
}

export function getNextUTCDate(n: number, skipWeekends: boolean = false) {
    let tdate = new Date();
    while (n > 0) {
        tdate.setUTCDate(tdate.getUTCDate() + 1);
        if (skipWeekends && tdate.getUTCDay() && tdate.getUTCDay() < 6) {
            n--;
        } else if (!skipWeekends) {
            n--;
        }
    }
    return Date.UTC(tdate.getUTCFullYear(), tdate.getUTCMonth(), tdate.getUTCDate());
}
